import ShLoadingIndicatorModalLazy from "../../../../../components/loading-indicator/shLoadingIndicatorModalLazy";
import { usePaypalState } from "../../../../../zustand/payment/helper/paypalState";

const ShCheckoutBraintreeLoadingIndicator = () => {
    const isLoading = usePaypalState(s => s.isPaypalLoading);
    const isPerforming = usePaypalState(s => s.isPaypalPerforming);

    return <>
        <ShLoadingIndicatorModalLazy isOpen={isLoading || isPerforming} />
    </>;
}

export default ShCheckoutBraintreeLoadingIndicator;
